var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex gap-2 text-primary mb-6" },
        [
          _c("v-icon", { attrs: { color: "primary", size: 20 } }, [
            _vm._v(" mdi-tag-outline "),
          ]),
          _c("span", { staticClass: "text-xl font-medium" }, [
            _vm._v(_vm._s(_vm.$t("promocode.header"))),
          ]),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "rounded-lg", attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c("div", { staticClass: "flex gap-4 flex-wrap" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center" },
                  [
                    _c("v-text-field", {
                      attrs: {
                        placeholder: _vm.$t("promocode.search.placeholder"),
                        "prepend-inner-icon": "mdi-magnify",
                        dense: "",
                        outlined: "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.code,
                        callback: function ($$v) {
                          _vm.code = $$v
                        },
                        expression: "code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex gap-2 sm:items-center flex-col sm:flex-row",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-base font-medium",
                        style: { minWidth: "80px" },
                      },
                      [_vm._v("ประเภทโค้ด")]
                    ),
                    _c("v-select", {
                      attrs: {
                        items: _vm.claimableEnum,
                        "item-text": "description",
                        "item-value": "name",
                        "prepend-inner-icon": "mdi-filter-variant",
                        attach: "",
                        dense: "",
                        outlined: "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.claimableFilter,
                        callback: function ($$v) {
                          _vm.claimableFilter = $$v
                        },
                        expression: "claimableFilter",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex gap-2 sm:items-center flex-col sm:flex-row",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-base font-medium",
                        style: { minWidth: "80px" },
                      },
                      [_vm._v("สถานะโค้ด")]
                    ),
                    _c("v-select", {
                      attrs: {
                        items: _vm.activeEnum,
                        "item-text": "description",
                        "item-value": "name",
                        "prepend-inner-icon": "mdi-filter-variant",
                        attach: "",
                        dense: "",
                        outlined: "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.activeFilter,
                        callback: function ($$v) {
                          _vm.activeFilter = $$v
                        },
                        expression: "activeFilter",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "flex justify-end w-full py-4" },
                [
                  _c("promocode-create", {
                    on: {
                      submit: function ($event) {
                        return _vm.refetchPromoCode()
                      },
                    },
                  }),
                ],
                1
              ),
              _c("promocode-data-table", {
                ref: "PromoCodeDataTable",
                attrs: {
                  "claimable-filter": _vm.claimableFilter,
                  "active-filter": _vm.activeFilter,
                  code: _vm.code,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }